import React from 'react';
import WaitingForIncidentMessage from '../shared/IncidentWidgets/WaitingForIncidentMessage';
import { connect } from 'react-redux';
import { selectCurrentDisplayedIncident } from '../../../../state/modules/incidents/selectors';
import { Row, Col, Card } from '../../../ui-kit';

const IncidentRadioChannels = props => {
  // Dummy data will be used if the dashboard is in edit mode
  const incident = props.displayedIncident;

  if (!incident) return <WaitingForIncidentMessage />;

  return (
    <Row className="g-2">
      {incident.radio_channels.map(r => (
        <Col key={r}>
          <Card bg="secondary" className="text-center">
            <Card.Body className="p-0">
              <h1 className="display-1 fw-bold">{r}</h1>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

const mapStateToProps = state => ({
  displayedIncident: selectCurrentDisplayedIncident(state)
});

export default connect(mapStateToProps)(IncidentRadioChannels);
